import  { useState } from "react";
import "./HelpCenter.css";

const faqs = [
  {
    question: "How do I publish my research on Axionnest?",
    answer:
      "To publish, log in to your account, click on 'Add New', select the type of content (journal, thesis, etc.), fill in the details, and click 'Submit'.",
  },
  {
    question: "Is there a limit to how many publications I can add?",
    answer:
      "No, Axionnest allows unlimited publications. Share as much content as you'd like to help others learn from your research.",
  },
  {
    question: "How do I search for specific journals or users?",
    answer:
      "Use the search bar at the top of the homepage. You can search by keywords, author names, or publication types.",
  },
  {
    question: "Can I edit or delete my publication?",
    answer:
      "Yes. Go to your profile, find the publication, and use the edit or delete options available under each post.",
  },
  {
    question: "How do I contact support if I face an issue?",
    answer:
      "If you need help, please use the Contact Us form or email us at support@axionnest.com. We usually respond within 24 hours.",
  },
];

const HelpCenter = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="helpcenter-container">
      <div className="helpcenter-content">
        <h1 className="helpcenter-title">Help Center</h1>
        <p className="helpcenter-subtext">
          Find answers to common questions and get help with using Axionnest.
        </p>

        <div className="faq-section">
          {faqs.map((faq, index) => (
            <div
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
              key={index}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <span>{faq.question}</span>
                <span className="arrow">
                  {activeIndex === index ? "▲" : "▼"}
                </span>
              </div>
              {activeIndex === index && (
                <div className="faq-answer">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HelpCenter;
